module.exports = __webpack_public_path__ + "static/media/_GPX0338.5a08bfdf.jpg";